import GlobalNotFound from '@skyscanner-internal/global-components/not-found';
import logger from 'saddlebag-logger';

import type { NotFoundProps } from '@shared/types/global-components/not-found-props';

type Props = NotFoundProps & {
  isProductionEnv: boolean;
};

const NotFound = (props: Props) => (
  <GlobalNotFound {...props} logger={logger} />
);

export default NotFound;
